import styled from 'styled-components';

const CategoryStyle = styled.div`
  .categoryHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 13px;
    .categoryTitle {
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
    }
    .viewAllButton {
      line-height: 17px;
      font-size: 14px;
      font-weight: 700;
      color: #1a9999;
      text-decoration: none;
      position: relative;
      .tealChevronRight {
        height: 12px;
        padding-left: 2px;
        position: relative;
        top: 1px;
      }
    }
  }

  amp-img {
    height: 12px;
    padding-left: 2px;
    position: relative;
    top: 1px;
  }
  .articleList {
    overflow-x: scroll;
    white-space: nowrap;
  }
`;

export default CategoryStyle;
